import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "row mb-2" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row mt-2" }
const _hoisted_4 = {
  for: "name",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_5 = { class: "col-sm-8" }
const _hoisted_6 = { class: "row mt-2" }
const _hoisted_7 = {
  for: "email",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_8 = { class: "col-sm-8" }
const _hoisted_9 = ["readonly"]
const _hoisted_10 = { class: "row mt-2" }
const _hoisted_11 = {
  for: "appId",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_12 = { class: "col-sm-8" }
const _hoisted_13 = { class: "row mt-2" }
const _hoisted_14 = {
  for: "is_blocked",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_15 = { class: "col-sm-8" }
const _hoisted_16 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_17 = { class: "row mt-2" }
const _hoisted_18 = {
  for: "isManualWithdrawals",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_19 = { class: "col-sm-8" }
const _hoisted_20 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_21 = { class: "row mt-2" }
const _hoisted_22 = {
  for: "isIpWhitelistEnabled",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_23 = { class: "col-sm-8" }
const _hoisted_24 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_25 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_26 = { class: "col-sm-8" }
const _hoisted_27 = {
  key: 1,
  class: "row mt-2"
}
const _hoisted_28 = {
  for: "createInvite",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_29 = { class: "col-sm-8" }
const _hoisted_30 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_31 = {
  key: 2,
  class: "row mt-2"
}
const _hoisted_32 = {
  for: "password",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_33 = { class: "col-sm-8" }
const _hoisted_34 = { class: "row mt-2" }
const _hoisted_35 = {
  for: "secret",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_36 = { class: "col-sm-8" }
const _hoisted_37 = { class: "input-group input-group-sm" }
const _hoisted_38 = {
  key: 3,
  class: ""
}
const _hoisted_39 = { class: "row mt-2" }
const _hoisted_40 = {
  for: "referralId",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_41 = { class: "col-sm-8" }
const _hoisted_42 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_43 = {
  for: "referralPayInFee",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_44 = { class: "col-sm-8 row" }
const _hoisted_45 = { class: "col-sm-3" }
const _hoisted_46 = { class: "col-sm-3 ms-2" }
const _hoisted_47 = {
  key: 1,
  class: "row mt-2"
}
const _hoisted_48 = {
  for: "referralPayOutFee",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_49 = { class: "col-sm-8 row" }
const _hoisted_50 = { class: "col-sm-3" }
const _hoisted_51 = { class: "col-sm-3 ms-2" }
const _hoisted_52 = { class: "row mt-2" }
const _hoisted_53 = {
  for: "referral2",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_54 = { class: "col-sm-8" }
const _hoisted_55 = {
  key: 2,
  class: "row mt-2"
}
const _hoisted_56 = {
  for: "referral2PayInFee",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_57 = { class: "col-sm-8 row" }
const _hoisted_58 = { class: "col-sm-3" }
const _hoisted_59 = { class: "col-sm-3 ms-2" }
const _hoisted_60 = {
  key: 3,
  class: "row mt-2"
}
const _hoisted_61 = {
  for: "referral2PayOutFee",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_62 = { class: "col-sm-8 row" }
const _hoisted_63 = { class: "col-sm-3" }
const _hoisted_64 = { class: "col-sm-3 ms-2" }
const _hoisted_65 = { class: "row mt-2" }
const _hoisted_66 = {
  for: "referral3",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_67 = { class: "col-sm-8" }
const _hoisted_68 = {
  key: 4,
  class: "row mt-2"
}
const _hoisted_69 = {
  for: "referral3PayInFee",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_70 = { class: "col-sm-8 row" }
const _hoisted_71 = { class: "col-sm-3" }
const _hoisted_72 = { class: "col-sm-3 ms-2" }
const _hoisted_73 = {
  key: 5,
  class: "row mt-2"
}
const _hoisted_74 = {
  for: "referral3PayOutFee",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_75 = { class: "col-sm-8 row" }
const _hoisted_76 = { class: "col-sm-3" }
const _hoisted_77 = { class: "col-sm-3 ms-2" }
const _hoisted_78 = { class: "row mt-2" }
const _hoisted_79 = {
  for: "referral4",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_80 = { class: "col-sm-8" }
const _hoisted_81 = {
  key: 6,
  class: "row mt-2"
}
const _hoisted_82 = {
  for: "referral4PayInFee",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_83 = { class: "col-sm-8 row" }
const _hoisted_84 = { class: "col-sm-3" }
const _hoisted_85 = { class: "col-sm-3 ms-2" }
const _hoisted_86 = {
  key: 7,
  class: "row mt-2"
}
const _hoisted_87 = {
  for: "referral4PayOutFee",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_88 = { class: "col-sm-8 row" }
const _hoisted_89 = { class: "col-sm-3" }
const _hoisted_90 = { class: "col-sm-3 ms-2" }
const _hoisted_91 = { class: "row mt-2" }
const _hoisted_92 = {
  for: "referral5",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_93 = { class: "col-sm-8" }
const _hoisted_94 = {
  key: 8,
  class: "row mt-2"
}
const _hoisted_95 = {
  for: "referral5PayInFee",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_96 = { class: "col-sm-8 row" }
const _hoisted_97 = { class: "col-sm-3" }
const _hoisted_98 = { class: "col-sm-3 ms-2" }
const _hoisted_99 = {
  key: 9,
  class: "row mt-2"
}
const _hoisted_100 = {
  for: "referral5PayOutFee",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_101 = { class: "col-sm-8 row" }
const _hoisted_102 = { class: "col-sm-3" }
const _hoisted_103 = { class: "col-sm-3 ms-2" }
const _hoisted_104 = { class: "row mt-2" }
const _hoisted_105 = {
  for: "rateSource",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_106 = { class: "col-sm-8" }
const _hoisted_107 = { class: "row mt-2" }
const _hoisted_108 = {
  for: "payOutRateSource",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_109 = { class: "col-sm-8" }
const _hoisted_110 = { class: "row mt-2" }
const _hoisted_111 = {
  for: "traderPayInRateSource",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_112 = { class: "col-sm-8" }
const _hoisted_113 = { class: "row mt-2" }
const _hoisted_114 = {
  for: "traderPayOutRateSource",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_115 = { class: "col-sm-8" }
const _hoisted_116 = { class: "row mt-2" }
const _hoisted_117 = {
  for: "tgChatGroupId",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_118 = { class: "col-sm-8" }
const _hoisted_119 = { class: "row mt-2" }
const _hoisted_120 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_121 = { class: "col-sm-8" }
const _hoisted_122 = { class: "text-muted d-block mt-1" }
const _hoisted_123 = { class: "row mt-2" }
const _hoisted_124 = {
  for: "isAvailableWorkWithUnsafeTgGroup",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_125 = { class: "col-sm-8" }
const _hoisted_126 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_127 = { class: "row mt-2" }
const _hoisted_128 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_129 = { class: "col-sm-8" }
const _hoisted_130 = { class: "mb-2" }
const _hoisted_131 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_132 = { class: "form-check form-switch mb-0 flex-shrink-0" }
const _hoisted_133 = ["onUpdate:modelValue", "value", "id"]
const _hoisted_134 = ["for", "title"]
const _hoisted_135 = ["onClick"]
const _hoisted_136 = { class: "row mt-3" }
const _hoisted_137 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_138 = { class: "row mt-2" }
const _hoisted_139 = {
  for: "turnoverReportTgGroupId",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_140 = { class: "col-sm-8" }
const _hoisted_141 = ["placeholder"]
const _hoisted_142 = { class: "text-muted d-block mt-1" }
const _hoisted_143 = { class: "row mt-2" }
const _hoisted_144 = {
  for: "turnoverReportSendHour",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_145 = { class: "col-sm-8" }
const _hoisted_146 = ["value"]
const _hoisted_147 = { class: "text-muted d-block mt-1" }
const _hoisted_148 = { class: "row mt-2" }
const _hoisted_149 = {
  for: "turnoverReportMiddayEnabled",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_150 = { class: "col-sm-8" }
const _hoisted_151 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_152 = { class: "row mt-3" }
const _hoisted_153 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_154 = { class: "row mt-2" }
const _hoisted_155 = {
  for: "conversionReportTgGroupId",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_156 = { class: "col-sm-8" }
const _hoisted_157 = ["placeholder"]
const _hoisted_158 = { class: "text-muted d-block mt-1" }
const _hoisted_159 = { class: "row mt-2" }
const _hoisted_160 = {
  for: "conversionReportSendHour",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_161 = { class: "col-sm-8" }
const _hoisted_162 = ["value"]
const _hoisted_163 = { class: "text-muted d-block mt-1" }
const _hoisted_164 = { class: "row mt-2" }
const _hoisted_165 = {
  for: "conversionReportMiddayEnabled",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_166 = { class: "col-sm-8" }
const _hoisted_167 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_168 = { class: "row mt-3" }
const _hoisted_169 = {
  for: "conversionStatTgGroupId",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_170 = { class: "col-sm-8" }
const _hoisted_171 = ["placeholder"]
const _hoisted_172 = { class: "text-muted d-block mt-1" }
const _hoisted_173 = { class: "row mt-2" }
const _hoisted_174 = {
  for: "isClientReceiptNotificationEnabled",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_175 = { class: "col-sm-8" }
const _hoisted_176 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_177 = {
  key: 10,
  class: "row mt-2"
}
const _hoisted_178 = {
  for: "isDealCompletedNotificationEnabled",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_179 = { class: "col-sm-8" }
const _hoisted_180 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_181 = {
  key: 0,
  class: "text-warning d-block mt-1"
}
const _hoisted_182 = {
  key: 11,
  class: "row mt-2"
}
const _hoisted_183 = {
  for: "reuseMinCapEnabled",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_184 = { class: "col-sm-8" }
const _hoisted_185 = { class: "form-check form-switch d-flex align-items-center mb-2" }
const _hoisted_186 = { class: "text-muted" }
const _hoisted_187 = { class: "row mt-2" }
const _hoisted_188 = {
  for: "siteUploadForwardEnabled",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_189 = { class: "col-sm-8" }
const _hoisted_190 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_191 = { class: "row mt-2" }
const _hoisted_192 = {
  for: "isAntiFraudEnabled",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_193 = { class: "col-sm-8" }
const _hoisted_194 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_195 = {
  key: 12,
  class: "row mt-2"
}
const _hoisted_196 = {
  for: "antiFraudCancelDeal",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_197 = { class: "col-sm-8" }
const _hoisted_198 = {
  key: 13,
  class: "row mt-2"
}
const _hoisted_199 = {
  for: "antiFraudCancelDealBannedSeconds",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_200 = { class: "col-sm-8 row" }
const _hoisted_201 = { class: "col-sm-3" }
const _hoisted_202 = ["placeholder"]
const _hoisted_203 = { class: "col-sm-3 ms-2" }
const _hoisted_204 = ["placeholder"]
const _hoisted_205 = {
  key: 14,
  class: "row mt-2"
}
const _hoisted_206 = {
  for: "2fa",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_207 = { class: "col-sm-8 align-items-center d-flex" }
const _hoisted_208 = {
  key: 0,
  class: "text-success"
}
const _hoisted_209 = {
  key: 1,
  class: "text-warning"
}
const _hoisted_210 = {
  key: 15,
  class: "row mt-3 mb-2"
}
const _hoisted_211 = { class: "col-sm-12 d-flex justify-content-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_CurrencyAmountMapInput = _resolveComponent("CurrencyAmountMapInput")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!
  const _component_MerchantReceiptForwardModal = _resolveComponent("MerchantReceiptForwardModal")!
  const _directive_maska = _resolveDirective("maska")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createElementBlock("form", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.helper.trans("labels.name")), 1),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors(`name`)
            }, {
              default: _withCtx((parentProps) => [
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass([parentProps.class, "form-control"]),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                  type: "text",
                  id: "name"
                }, null, 2), [
                  [_vModelText, _ctx.form.name]
                ])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.helper.trans("labels.email")), 1),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors(`email`)
            }, {
              default: _withCtx((parentProps) => [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.email) = $event)),
                  class: _normalizeClass([parentProps.class, "form-control"]),
                  readonly: !!_ctx.form.id,
                  type: "text",
                  id: "email"
                }, null, 10, _hoisted_9), [
                  [_vModelText, _ctx.form.email]
                ])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.helper.trans("labels.domain")), 1),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors(`appId`)
            }, {
              default: _withCtx((parentProps) => [
                _createVNode(_component_Multiselect, {
                  id: "referralId",
                  class: _normalizeClass(["", parentProps.class]),
                  modelValue: _ctx.form.appId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.appId) = $event)),
                  options: _ctx.store.getters['getAppsIds'],
                  "custom-label": (opt) => _ctx.store.getters['getAppById'](opt)?.domain,
                  "select-label": "Select",
                  placeholder: "",
                  "open-direction": "bottom",
                  multiple: false,
                  searchable: true,
                  "internal-search": true,
                  "clear-on-select": false,
                  "close-on-select": true,
                  "options-limit": 100,
                  limit: 1000,
                  "show-no-results": false,
                  "hide-selected": false
                }, null, 8, ["class", "modelValue", "options", "custom-label"])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.helper.trans("labels.is_blocked")), 1),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.isBlocked) = $event)),
                class: "form-check-input",
                type: "checkbox",
                id: "is_blocked"
              }, null, 512), [
                [_vModelCheckbox, _ctx.form.isBlocked]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.helper.trans("labels.isManualWithdrawals")), 1),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.isManualWithdrawals) = $event)),
                class: "form-check-input",
                type: "checkbox",
                id: "isManualWithdrawals"
              }, null, 512), [
                [_vModelCheckbox, _ctx.form.isManualWithdrawals]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.helper.trans("labels.is_ip_whitelist_enabled")), 1),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.isIpWhitelistEnabled) = $event)),
                class: "form-check-input",
                type: "checkbox",
                id: "isIpWhitelistEnabled"
              }, null, 512), [
                [_vModelCheckbox, _ctx.form.isIpWhitelistEnabled]
              ])
            ])
          ])
        ]),
        (_ctx.form.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _cache[66] || (_cache[66] = _createElementVNode("div", { class: "col-sm-4" }, null, -1)),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-outline-dark text-capitalize-first",
                  onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.$emit('open-ip-whitelist')), ["prevent"]))
                }, _toDisplayString(_ctx.helper.trans('labels.merchant_ip_whitelist')), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.form.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.helper.trans("labels.create_invite")), 1),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.createInvite) = $event)),
                    class: "form-check-input",
                    type: "checkbox",
                    id: "createInvite"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.form.createInvite]
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        ((_ctx.form.id || _ctx.form.createInvite === false) && _ctx.store.getters.hasPermission(_ctx.UserPermission.RESET_MERCHANT_PASSWORD))
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.helper.trans("labels.password")), 1),
              _createElementVNode("div", _hoisted_33, [
                _createVNode(_component_FormInputWrapper, {
                  errors: _ctx.getErrors(`password`)
                }, {
                  default: _withCtx((parentProps) => [
                    _createElementVNode("div", {
                      class: _normalizeClass(["input-group", parentProps.class])
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.password) = $event)),
                        class: _normalizeClass([parentProps.class, "form-control"]),
                        type: "text",
                        id: "password"
                      }, null, 2), [
                        [_vModelText, _ctx.form.password]
                      ]),
                      _createElementVNode("button", {
                        onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.form.password = _ctx.helper.generatePassword()), ["prevent"])),
                        type: "button",
                        class: "btn btn-outline-secondary"
                      }, _cache[67] || (_cache[67] = [
                        _createElementVNode("i", { class: "fa fa-rotate" }, null, -1)
                      ]))
                    ], 2)
                  ]),
                  _: 1
                }, 8, ["errors"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.helper.trans("labels.secret")), 1),
          _createElementVNode("div", _hoisted_36, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors(`secret`)
            }, {
              default: _withCtx((parentProps) => [
                _createElementVNode("div", _hoisted_37, [
                  _withDirectives(_createElementVNode("input", {
                    readonly: "",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.secret) = $event)),
                    class: _normalizeClass([parentProps.class, "form-control"]),
                    type: "text",
                    id: "secret"
                  }, null, 2), [
                    [_vModelText, _ctx.form.secret]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-secondary",
                    onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.form.secret = _ctx.helper.generateRandomString(40)), ["prevent"]))
                  }, _cache[68] || (_cache[68] = [
                    _createElementVNode("i", { class: "fa fa-rotate" }, null, -1)
                  ]))
                ])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        (_ctx.store.getters.isAdmin)
          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.helper.trans("labels.referral")), 1),
                _createElementVNode("div", _hoisted_41, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.getErrors(`referralId`)
                  }, {
                    default: _withCtx((parentProps) => [
                      _createVNode(_component_Multiselect, {
                        id: "referralId",
                        class: _normalizeClass(["", parentProps.class]),
                        modelValue: _ctx.form.referral,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.referral) = $event)),
                        "track-by": "id",
                        options: _ctx.referrals,
                        "custom-label": (opt) => `${opt.name} (${opt.email})`,
                        "custom-value": (opt) => opt.id,
                        "select-label": "Select",
                        placeholder: "",
                        "open-direction": "bottom",
                        multiple: false,
                        searchable: true,
                        "internal-search": true,
                        "clear-on-select": false,
                        "close-on-select": true,
                        "options-limit": 100,
                        limit: 1000,
                        "show-no-results": false,
                        "hide-selected": false,
                        onSearchChange: _ctx.asyncFindReferrals,
                        loading: _ctx.isReferralsSelectLoading
                      }, null, 8, ["class", "modelValue", "options", "custom-label", "custom-value", "onSearchChange", "loading"])
                    ]),
                    _: 1
                  }, 8, ["errors"])
                ])
              ]),
              (_ctx.form.referral)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.helper.trans("labels.pay_in_reward_fee_percent")), 1),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _createVNode(_component_FormInputWrapper, {
                          errors: _ctx.getErrors(`referralPayInFee`)
                        }, {
                          default: _withCtx((parentProps) => [
                            _createElementVNode("div", {
                              class: _normalizeClass(parentProps.class)
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.referralPayInFee) = $event)),
                                type: "text",
                                class: _normalizeClass(["form-control", parentProps.class]),
                                id: "referralPayInFee",
                                "data-maska": "99.99",
                                "data-maska-tokens": "9:[0-9]:optional"
                              }, null, 2), [
                                [_vModelText, _ctx.form.referralPayInFee],
                                [_directive_maska]
                              ])
                            ], 2)
                          ]),
                          _: 1
                        }, 8, ["errors"])
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("button", {
                          onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.toggleRefPayInType(1)), ["prevent"])),
                          class: "btn btn-outline-secondary",
                          type: "button"
                        }, _toDisplayString(_ctx.helper.trans(`labels.ref_fee_type.${_ctx.form.referralPayInFeeType}`)), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.form.referral)
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.helper.trans("labels.pay_out_reward_fee_percent")), 1),
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _createVNode(_component_FormInputWrapper, {
                          errors: _ctx.getErrors(`referralPayOutFee`)
                        }, {
                          default: _withCtx((parentProps) => [
                            _createElementVNode("div", {
                              class: _normalizeClass(parentProps.class)
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.referralPayOutFee) = $event)),
                                type: "text",
                                class: _normalizeClass(["form-control", parentProps.class]),
                                id: "referralPayOutFee",
                                "data-maska": "99.99",
                                "data-maska-tokens": "9:[0-9]:optional"
                              }, null, 2), [
                                [_vModelText, _ctx.form.referralPayOutFee],
                                [_directive_maska]
                              ])
                            ], 2)
                          ]),
                          _: 1
                        }, 8, ["errors"])
                      ]),
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("button", {
                          onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (_ctx.toggleRefPayOutType(1)), ["prevent"])),
                          class: "btn btn-outline-secondary",
                          type: "button"
                        }, _toDisplayString(_ctx.helper.trans(`labels.ref_fee_type.${_ctx.form.referralPayOutFeeType}`)), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.helper.trans("labels.referral")) + " 2", 1),
                _createElementVNode("div", _hoisted_54, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.getErrors(`referral2`)
                  }, {
                    default: _withCtx((parentProps) => [
                      _createVNode(_component_Multiselect, {
                        id: "referral2",
                        class: _normalizeClass(["", parentProps.class]),
                        modelValue: _ctx.form.referral2,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.referral2) = $event)),
                        "track-by": "id",
                        options: _ctx.referrals,
                        "custom-label": (opt) => `${opt.name} (${opt.email})`,
                        "custom-value": (opt) => opt.id,
                        "select-label": "Select",
                        placeholder: "",
                        "open-direction": "bottom",
                        multiple: false,
                        searchable: true,
                        "internal-search": true,
                        "clear-on-select": false,
                        "close-on-select": true,
                        "options-limit": 100,
                        limit: 1000,
                        "show-no-results": false,
                        "hide-selected": false,
                        onSearchChange: _ctx.asyncFindReferrals,
                        loading: _ctx.isReferralsSelectLoading
                      }, null, 8, ["class", "modelValue", "options", "custom-label", "custom-value", "onSearchChange", "loading"])
                    ]),
                    _: 1
                  }, 8, ["errors"])
                ])
              ]),
              (_ctx.form.referral2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                    _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.helper.trans("labels.pay_in_reward_fee_percent")), 1),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, [
                        _createVNode(_component_FormInputWrapper, {
                          errors: _ctx.getErrors(`referral2PayInFee`)
                        }, {
                          default: _withCtx((parentProps) => [
                            _createElementVNode("div", {
                              class: _normalizeClass(parentProps.class)
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.referral2PayInFee) = $event)),
                                type: "text",
                                class: _normalizeClass(["form-control", parentProps.class]),
                                id: "referral2PayInFee",
                                "data-maska": "99.99",
                                "data-maska-tokens": "9:[0-9]:optional"
                              }, null, 2), [
                                [_vModelText, _ctx.form.referral2PayInFee],
                                [_directive_maska]
                              ])
                            ], 2)
                          ]),
                          _: 1
                        }, 8, ["errors"])
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("button", {
                          onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.toggleRefPayInType(2)), ["prevent"])),
                          class: "btn btn-outline-secondary",
                          type: "button"
                        }, _toDisplayString(_ctx.helper.trans(`labels.ref_fee_type.${_ctx.form.referral2PayInFeeType}`)), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.form.referral2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                    _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.helper.trans("labels.pay_out_reward_fee_percent")), 1),
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("div", _hoisted_63, [
                        _createVNode(_component_FormInputWrapper, {
                          errors: _ctx.getErrors(`referral2PayOutFee`)
                        }, {
                          default: _withCtx((parentProps) => [
                            _createElementVNode("div", {
                              class: _normalizeClass(parentProps.class)
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.referral2PayOutFee) = $event)),
                                type: "text",
                                class: _normalizeClass(["form-control", parentProps.class]),
                                id: "referral2PayOutFee",
                                "data-maska": "99.99",
                                "data-maska-tokens": "9:[0-9]:optional"
                              }, null, 2), [
                                [_vModelText, _ctx.form.referral2PayOutFee],
                                [_directive_maska]
                              ])
                            ], 2)
                          ]),
                          _: 1
                        }, 8, ["errors"])
                      ]),
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("button", {
                          onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (_ctx.toggleRefPayOutType(2)), ["prevent"])),
                          class: "btn btn-outline-secondary",
                          type: "button"
                        }, _toDisplayString(_ctx.helper.trans(`labels.ref_fee_type.${_ctx.form.referral2PayOutFeeType}`)), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("label", _hoisted_66, _toDisplayString(_ctx.helper.trans("labels.referral")) + " 3", 1),
                _createElementVNode("div", _hoisted_67, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.getErrors(`referral3`)
                  }, {
                    default: _withCtx((parentProps) => [
                      _createVNode(_component_Multiselect, {
                        id: "referral3",
                        class: _normalizeClass(["", parentProps.class]),
                        modelValue: _ctx.form.referral3,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.referral3) = $event)),
                        "track-by": "id",
                        options: _ctx.referrals,
                        "custom-label": (opt) => `${opt.name} (${opt.email})`,
                        "custom-value": (opt) => opt.id,
                        "select-label": "Select",
                        placeholder: "",
                        "open-direction": "bottom",
                        multiple: false,
                        searchable: true,
                        "internal-search": true,
                        "clear-on-select": false,
                        "close-on-select": true,
                        "options-limit": 100,
                        limit: 1000,
                        "show-no-results": false,
                        "hide-selected": false,
                        onSearchChange: _ctx.asyncFindReferrals,
                        loading: _ctx.isReferralsSelectLoading
                      }, null, 8, ["class", "modelValue", "options", "custom-label", "custom-value", "onSearchChange", "loading"])
                    ]),
                    _: 1
                  }, 8, ["errors"])
                ])
              ]),
              (_ctx.form.referral3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                    _createElementVNode("label", _hoisted_69, _toDisplayString(_ctx.helper.trans("labels.pay_in_reward_fee_percent")), 1),
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("div", _hoisted_71, [
                        _createVNode(_component_FormInputWrapper, {
                          errors: _ctx.getErrors(`referral3PayInFee`)
                        }, {
                          default: _withCtx((parentProps) => [
                            _createElementVNode("div", {
                              class: _normalizeClass(parentProps.class)
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.referral3PayInFee) = $event)),
                                type: "text",
                                class: _normalizeClass(["form-control", parentProps.class]),
                                id: "referral3PayInFee",
                                "data-maska": "99.99",
                                "data-maska-tokens": "9:[0-9]:optional"
                              }, null, 2), [
                                [_vModelText, _ctx.form.referral3PayInFee],
                                [_directive_maska]
                              ])
                            ], 2)
                          ]),
                          _: 1
                        }, 8, ["errors"])
                      ]),
                      _createElementVNode("div", _hoisted_72, [
                        _createElementVNode("button", {
                          onClick: _cache[24] || (_cache[24] = _withModifiers(($event: any) => (_ctx.toggleRefPayInType(3)), ["prevent"])),
                          class: "btn btn-outline-secondary",
                          type: "button"
                        }, _toDisplayString(_ctx.helper.trans(`labels.ref_fee_type.${_ctx.form.referral3PayInFeeType}`)), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.form.referral3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                    _createElementVNode("label", _hoisted_74, _toDisplayString(_ctx.helper.trans("labels.pay_out_reward_fee_percent")), 1),
                    _createElementVNode("div", _hoisted_75, [
                      _createElementVNode("div", _hoisted_76, [
                        _createVNode(_component_FormInputWrapper, {
                          errors: _ctx.getErrors(`referral3PayOutFee`)
                        }, {
                          default: _withCtx((parentProps) => [
                            _createElementVNode("div", {
                              class: _normalizeClass(parentProps.class)
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.form.referral3PayOutFee) = $event)),
                                type: "text",
                                class: _normalizeClass(["form-control", parentProps.class]),
                                id: "referral3PayOutFee",
                                "data-maska": "99.99",
                                "data-maska-tokens": "9:[0-9]:optional"
                              }, null, 2), [
                                [_vModelText, _ctx.form.referral3PayOutFee],
                                [_directive_maska]
                              ])
                            ], 2)
                          ]),
                          _: 1
                        }, 8, ["errors"])
                      ]),
                      _createElementVNode("div", _hoisted_77, [
                        _createElementVNode("button", {
                          onClick: _cache[26] || (_cache[26] = _withModifiers(($event: any) => (_ctx.toggleRefPayOutType(3)), ["prevent"])),
                          class: "btn btn-outline-secondary",
                          type: "button"
                        }, _toDisplayString(_ctx.helper.trans(`labels.ref_fee_type.${_ctx.form.referral3PayOutFeeType}`)), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("label", _hoisted_79, _toDisplayString(_ctx.helper.trans("labels.referral")) + " 4", 1),
                _createElementVNode("div", _hoisted_80, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.getErrors(`referral4`)
                  }, {
                    default: _withCtx((parentProps) => [
                      _createVNode(_component_Multiselect, {
                        id: "referral4",
                        class: _normalizeClass(["", parentProps.class]),
                        modelValue: _ctx.form.referral4,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.referral4) = $event)),
                        "track-by": "id",
                        options: _ctx.referrals,
                        "custom-label": (opt) => `${opt.name} (${opt.email})`,
                        "custom-value": (opt) => opt.id,
                        "select-label": "Select",
                        placeholder: "",
                        "open-direction": "bottom",
                        multiple: false,
                        searchable: true,
                        "internal-search": true,
                        "clear-on-select": false,
                        "close-on-select": true,
                        "options-limit": 100,
                        limit: 1000,
                        "show-no-results": false,
                        "hide-selected": false,
                        onSearchChange: _ctx.asyncFindReferrals,
                        loading: _ctx.isReferralsSelectLoading
                      }, null, 8, ["class", "modelValue", "options", "custom-label", "custom-value", "onSearchChange", "loading"])
                    ]),
                    _: 1
                  }, 8, ["errors"])
                ])
              ]),
              (_ctx.form.referral4)
                ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                    _createElementVNode("label", _hoisted_82, _toDisplayString(_ctx.helper.trans("labels.pay_in_reward_fee_percent")), 1),
                    _createElementVNode("div", _hoisted_83, [
                      _createElementVNode("div", _hoisted_84, [
                        _createVNode(_component_FormInputWrapper, {
                          errors: _ctx.getErrors(`referral4PayInFee`)
                        }, {
                          default: _withCtx((parentProps) => [
                            _createElementVNode("div", {
                              class: _normalizeClass(parentProps.class)
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.referral4PayInFee) = $event)),
                                type: "text",
                                class: _normalizeClass(["form-control", parentProps.class]),
                                id: "referral4PayInFee",
                                "data-maska": "99.99",
                                "data-maska-tokens": "9:[0-9]:optional"
                              }, null, 2), [
                                [_vModelText, _ctx.form.referral4PayInFee],
                                [_directive_maska]
                              ])
                            ], 2)
                          ]),
                          _: 1
                        }, 8, ["errors"])
                      ]),
                      _createElementVNode("div", _hoisted_85, [
                        _createElementVNode("button", {
                          onClick: _cache[29] || (_cache[29] = _withModifiers(($event: any) => (_ctx.toggleRefPayInType(4)), ["prevent"])),
                          class: "btn btn-outline-secondary",
                          type: "button"
                        }, _toDisplayString(_ctx.helper.trans(`labels.ref_fee_type.${_ctx.form.referral4PayInFeeType}`)), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.form.referral4)
                ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                    _createElementVNode("label", _hoisted_87, _toDisplayString(_ctx.helper.trans("labels.pay_out_reward_fee_percent")), 1),
                    _createElementVNode("div", _hoisted_88, [
                      _createElementVNode("div", _hoisted_89, [
                        _createVNode(_component_FormInputWrapper, {
                          errors: _ctx.getErrors(`referral4PayOutFee`)
                        }, {
                          default: _withCtx((parentProps) => [
                            _createElementVNode("div", {
                              class: _normalizeClass(parentProps.class)
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.form.referral4PayOutFee) = $event)),
                                type: "text",
                                class: _normalizeClass(["form-control", parentProps.class]),
                                id: "referral4PayOutFee",
                                "data-maska": "99.99",
                                "data-maska-tokens": "9:[0-9]:optional"
                              }, null, 2), [
                                [_vModelText, _ctx.form.referral4PayOutFee],
                                [_directive_maska]
                              ])
                            ], 2)
                          ]),
                          _: 1
                        }, 8, ["errors"])
                      ]),
                      _createElementVNode("div", _hoisted_90, [
                        _createElementVNode("button", {
                          onClick: _cache[31] || (_cache[31] = _withModifiers(($event: any) => (_ctx.toggleRefPayOutType(4)), ["prevent"])),
                          class: "btn btn-outline-secondary",
                          type: "button"
                        }, _toDisplayString(_ctx.helper.trans(`labels.ref_fee_type.${_ctx.form.referral4PayOutFeeType}`)), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_91, [
                _createElementVNode("label", _hoisted_92, _toDisplayString(_ctx.helper.trans("labels.referral")) + " 5", 1),
                _createElementVNode("div", _hoisted_93, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.getErrors(`referral5`)
                  }, {
                    default: _withCtx((parentProps) => [
                      _createVNode(_component_Multiselect, {
                        id: "referral5",
                        class: _normalizeClass(["", parentProps.class]),
                        modelValue: _ctx.form.referral5,
                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.form.referral5) = $event)),
                        "track-by": "id",
                        options: _ctx.referrals,
                        "custom-label": (opt) => `${opt.name} (${opt.email})`,
                        "custom-value": (opt) => opt.id,
                        "select-label": "Select",
                        placeholder: "",
                        "open-direction": "bottom",
                        multiple: false,
                        searchable: true,
                        "internal-search": true,
                        "clear-on-select": false,
                        "close-on-select": true,
                        "options-limit": 100,
                        limit: 1000,
                        "show-no-results": false,
                        "hide-selected": false,
                        onSearchChange: _ctx.asyncFindReferrals,
                        loading: _ctx.isReferralsSelectLoading
                      }, null, 8, ["class", "modelValue", "options", "custom-label", "custom-value", "onSearchChange", "loading"])
                    ]),
                    _: 1
                  }, 8, ["errors"])
                ])
              ]),
              (_ctx.form.referral5)
                ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                    _createElementVNode("label", _hoisted_95, _toDisplayString(_ctx.helper.trans("labels.pay_in_reward_fee_percent")), 1),
                    _createElementVNode("div", _hoisted_96, [
                      _createElementVNode("div", _hoisted_97, [
                        _createVNode(_component_FormInputWrapper, {
                          errors: _ctx.getErrors(`referral5PayInFee`)
                        }, {
                          default: _withCtx((parentProps) => [
                            _createElementVNode("div", {
                              class: _normalizeClass(parentProps.class)
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.form.referral5PayInFee) = $event)),
                                type: "text",
                                class: _normalizeClass(["form-control", parentProps.class]),
                                id: "referral5PayInFee",
                                "data-maska": "99.99",
                                "data-maska-tokens": "9:[0-9]:optional"
                              }, null, 2), [
                                [_vModelText, _ctx.form.referral5PayInFee],
                                [_directive_maska]
                              ])
                            ], 2)
                          ]),
                          _: 1
                        }, 8, ["errors"])
                      ]),
                      _createElementVNode("div", _hoisted_98, [
                        _createElementVNode("button", {
                          onClick: _cache[34] || (_cache[34] = _withModifiers(($event: any) => (_ctx.toggleRefPayInType(5)), ["prevent"])),
                          class: "btn btn-outline-secondary",
                          type: "button"
                        }, _toDisplayString(_ctx.helper.trans(`labels.ref_fee_type.${_ctx.form.referral5PayInFeeType}`)), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.form.referral5)
                ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                    _createElementVNode("label", _hoisted_100, _toDisplayString(_ctx.helper.trans("labels.pay_out_reward_fee_percent")), 1),
                    _createElementVNode("div", _hoisted_101, [
                      _createElementVNode("div", _hoisted_102, [
                        _createVNode(_component_FormInputWrapper, {
                          errors: _ctx.getErrors(`referral5PayOutFee`)
                        }, {
                          default: _withCtx((parentProps) => [
                            _createElementVNode("div", {
                              class: _normalizeClass(parentProps.class)
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.form.referral5PayOutFee) = $event)),
                                type: "text",
                                class: _normalizeClass(["form-control", parentProps.class]),
                                id: "referral5PayOutFee",
                                "data-maska": "99.99",
                                "data-maska-tokens": "9:[0-9]:optional"
                              }, null, 2), [
                                [_vModelText, _ctx.form.referral5PayOutFee],
                                [_directive_maska]
                              ])
                            ], 2)
                          ]),
                          _: 1
                        }, 8, ["errors"])
                      ]),
                      _createElementVNode("div", _hoisted_103, [
                        _createElementVNode("button", {
                          onClick: _cache[36] || (_cache[36] = _withModifiers(($event: any) => (_ctx.toggleRefPayOutType(5)), ["prevent"])),
                          class: "btn btn-outline-secondary",
                          type: "button"
                        }, _toDisplayString(_ctx.helper.trans(`labels.ref_fee_type.${_ctx.form.referral5PayOutFeeType}`)), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_104, [
                _createElementVNode("label", _hoisted_105, _toDisplayString(_ctx.helper.trans("labels.rate_source")) + ", in", 1),
                _createElementVNode("div", _hoisted_106, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.getErrors(`rateSource`)
                  }, {
                    default: _withCtx((parentProps) => [
                      _createVNode(_component_Multiselect, {
                        id: "parentId",
                        class: _normalizeClass(["", parentProps.class]),
                        modelValue: _ctx.form.rateSource,
                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.form.rateSource) = $event)),
                        options: _ctx.store.getters['rateSources/all'],
                        "custom-label": (opt) => _ctx.store.getters['rateSources/get'](opt)?.name,
                        "select-label": "Select",
                        placeholder: "",
                        "open-direction": "bottom",
                        multiple: false,
                        searchable: true,
                        "internal-search": true,
                        "clear-on-select": false,
                        "close-on-select": true,
                        "options-limit": 100,
                        limit: 1000,
                        "show-no-results": false,
                        "hide-selected": false
                      }, null, 8, ["class", "modelValue", "options", "custom-label"])
                    ]),
                    _: 1
                  }, 8, ["errors"])
                ])
              ]),
              _createElementVNode("div", _hoisted_107, [
                _createElementVNode("label", _hoisted_108, _toDisplayString(_ctx.helper.trans("labels.rate_source")) + ", out", 1),
                _createElementVNode("div", _hoisted_109, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.getErrors(`payOutRateSource`)
                  }, {
                    default: _withCtx((parentProps) => [
                      _createVNode(_component_Multiselect, {
                        id: "parentId",
                        class: _normalizeClass(["", parentProps.class]),
                        modelValue: _ctx.form.payOutRateSource,
                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.form.payOutRateSource) = $event)),
                        options: _ctx.store.getters['rateSources/all'],
                        "custom-label": (opt) => _ctx.store.getters['rateSources/get'](opt)?.name,
                        "select-label": "Select",
                        placeholder: "",
                        "open-direction": "bottom",
                        multiple: false,
                        searchable: true,
                        "internal-search": true,
                        "clear-on-select": false,
                        "close-on-select": true,
                        "options-limit": 100,
                        limit: 1000,
                        "show-no-results": false,
                        "hide-selected": false
                      }, null, 8, ["class", "modelValue", "options", "custom-label"])
                    ]),
                    _: 1
                  }, 8, ["errors"])
                ])
              ]),
              _createElementVNode("div", _hoisted_110, [
                _createElementVNode("label", _hoisted_111, _toDisplayString(_ctx.helper.trans("labels.trader_rate_source")) + ", in", 1),
                _createElementVNode("div", _hoisted_112, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.getErrors(`traderPayInRateSource`)
                  }, {
                    default: _withCtx((parentProps) => [
                      _createVNode(_component_Multiselect, {
                        id: "parentId",
                        class: _normalizeClass(["", parentProps.class]),
                        modelValue: _ctx.form.traderPayInRateSource,
                        "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.form.traderPayInRateSource) = $event)),
                        options: _ctx.store.getters['rateSources/all'],
                        "custom-label": (opt) => _ctx.store.getters['rateSources/get'](opt)?.name,
                        "select-label": "Select",
                        placeholder: "",
                        "open-direction": "bottom",
                        multiple: false,
                        searchable: true,
                        "internal-search": true,
                        "clear-on-select": false,
                        "close-on-select": true,
                        "options-limit": 100,
                        limit: 1000,
                        "show-no-results": false,
                        "hide-selected": false
                      }, null, 8, ["class", "modelValue", "options", "custom-label"])
                    ]),
                    _: 1
                  }, 8, ["errors"])
                ])
              ]),
              _createElementVNode("div", _hoisted_113, [
                _createElementVNode("label", _hoisted_114, _toDisplayString(_ctx.helper.trans("labels.trader_rate_source")) + ", out", 1),
                _createElementVNode("div", _hoisted_115, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.getErrors(`traderPayOutRateSource`)
                  }, {
                    default: _withCtx((parentProps) => [
                      _createVNode(_component_Multiselect, {
                        id: "parentId",
                        class: _normalizeClass(["", parentProps.class]),
                        modelValue: _ctx.form.traderPayOutRateSource,
                        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.form.traderPayOutRateSource) = $event)),
                        options: _ctx.store.getters['rateSources/all'],
                        "custom-label": (opt) => _ctx.store.getters['rateSources/get'](opt)?.name,
                        "select-label": "Select",
                        placeholder: "",
                        "open-direction": "bottom",
                        multiple: false,
                        searchable: true,
                        "internal-search": true,
                        "clear-on-select": false,
                        "close-on-select": true,
                        "options-limit": 100,
                        limit: 1000,
                        "show-no-results": false,
                        "hide-selected": false
                      }, null, 8, ["class", "modelValue", "options", "custom-label"])
                    ]),
                    _: 1
                  }, 8, ["errors"])
                ])
              ]),
              _createElementVNode("div", _hoisted_116, [
                _createElementVNode("label", _hoisted_117, _toDisplayString(_ctx.helper.trans("labels.main_tg_group_id")), 1),
                _createElementVNode("div", _hoisted_118, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.getErrors(`tgChatGroupId`)
                  }, {
                    default: _withCtx((parentProps) => [
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass([parentProps.class, "form-control"]),
                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.form.tgChatGroupId) = $event)),
                        type: "text",
                        id: "tgChatGroupId"
                      }, null, 2), [
                        [_vModelText, _ctx.form.tgChatGroupId]
                      ])
                    ]),
                    _: 1
                  }, 8, ["errors"])
                ])
              ]),
              _createElementVNode("div", _hoisted_119, [
                _createElementVNode("label", _hoisted_120, _toDisplayString(_ctx.helper.trans("labels.receipt_forward_settings")), 1),
                _createElementVNode("div", _hoisted_121, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-secondary btn-sm text-capitalize-first",
                    onClick: _cache[42] || (_cache[42] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openReceiptForwardModal && _ctx.openReceiptForwardModal(...args)), ["prevent"]))
                  }, _toDisplayString(_ctx.helper.trans('labels.receipt_forward_configure')), 1),
                  _createElementVNode("small", _hoisted_122, _toDisplayString(_ctx.receiptForwardSummary), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_123, [
                _createElementVNode("label", _hoisted_124, _toDisplayString(_ctx.helper.trans("labels.isAvailableWorkWithUnsafeTgGroup")), 1),
                _createElementVNode("div", _hoisted_125, [
                  _createElementVNode("div", _hoisted_126, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.form.isAvailableWorkWithUnsafeTgGroup) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "isAvailableWorkWithUnsafeTgGroup"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.isAvailableWorkWithUnsafeTgGroup]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_127, [
                _createElementVNode("label", _hoisted_128, _toDisplayString(_ctx.helper.trans("labels.additional_groups")), 1),
                _createElementVNode("div", _hoisted_129, [
                  _createElementVNode("div", _hoisted_130, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.tgGroups, (group, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "d-flex flex-row align-items-center gap-2 mb-2"
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((group.tgGroupId) = $event),
                          type: "text",
                          class: "form-control",
                          placeholder: _ctx.helper.trans('labels.group_id_placeholder', {number: index + 1})
                        }, null, 8, _hoisted_131), [
                          [_vModelText, group.tgGroupId]
                        ]),
                        _createElementVNode("div", _hoisted_132, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((group.roles) = $event),
                            type: "checkbox",
                            class: "form-check-input",
                            value: _ctx.MerchantTgGroupRole.DISPUTE_CREATION,
                            id: `tgGroupDisputeCreation${index}`
                          }, null, 8, _hoisted_133), [
                            [_vModelCheckbox, group.roles]
                          ]),
                          _withDirectives((_openBlock(), _createElementBlock("label", {
                            class: "form-check-label text-nowrap",
                            for: `tgGroupDisputeCreation${index}`,
                            title: _ctx.helper.trans('labels.tg_group_dispute_creation_role')
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.helper.trans('labels.tg_group_dispute_here')), 1)
                          ], 8, _hoisted_134)), [
                            [
                              _directive_b_tooltip,
                              void 0,
                              void 0,
                              { hover: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: ($event: any) => (_ctx.removeTgGroup(index)),
                          class: "btn btn-outline-danger btn-sm flex-shrink-0"
                        }, _cache[69] || (_cache[69] = [
                          _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                        ]), 8, _hoisted_135)
                      ]))
                    }), 128)),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[44] || (_cache[44] = 
//@ts-ignore
(...args) => (_ctx.addTgGroup && _ctx.addTgGroup(...args))),
                      class: "btn btn-outline-primary btn-sm"
                    }, [
                      _cache[70] || (_cache[70] = _createElementVNode("i", { class: "fa fa-plus" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.helper.trans("button.add_group")), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_136, [
                _createElementVNode("label", _hoisted_137, _toDisplayString(_ctx.helper.trans("labels.turnover_report_settings")), 1),
                _cache[71] || (_cache[71] = _createElementVNode("div", { class: "col-sm-8" }, null, -1))
              ]),
              _createElementVNode("div", _hoisted_138, [
                _createElementVNode("label", _hoisted_139, _toDisplayString(_ctx.helper.trans("labels.turnover_report_tg_group_id")), 1),
                _createElementVNode("div", _hoisted_140, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.getErrors(`turnoverReportTgGroupId`)
                  }, {
                    default: _withCtx((parentProps) => [
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass([parentProps.class, "form-control"]),
                        "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.form.turnoverReportTgGroupId) = $event)),
                        type: "text",
                        id: "turnoverReportTgGroupId",
                        placeholder: _ctx.helper.trans('labels.turnover_report_tg_group_id_placeholder')
                      }, null, 10, _hoisted_141), [
                        [_vModelText, _ctx.form.turnoverReportTgGroupId]
                      ])
                    ]),
                    _: 1
                  }, 8, ["errors"]),
                  _createElementVNode("small", _hoisted_142, _toDisplayString(_ctx.helper.trans("labels.turnover_report_tg_group_id_hint")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_143, [
                _createElementVNode("label", _hoisted_144, _toDisplayString(_ctx.helper.trans("labels.turnover_report_send_hour")), 1),
                _createElementVNode("div", _hoisted_145, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.getTurnoverReportErrors(`turnoverReportSendHour`)
                  }, {
                    default: _withCtx((parentProps) => [
                      _withDirectives(_createElementVNode("select", {
                        id: "turnoverReportSendHour",
                        "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.form.turnoverReportSendHour) = $event)),
                        class: _normalizeClass(["form-select", parentProps.class])
                      }, [
                        _cache[72] || (_cache[72] = _createElementVNode("option", { value: null }, null, -1)),
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(24, (hour) => {
                          return _createElementVNode("option", {
                            key: hour - 1,
                            value: hour - 1
                          }, _toDisplayString(hour - 1), 9, _hoisted_146)
                        }), 64))
                      ], 2), [
                        [_vModelSelect, _ctx.form.turnoverReportSendHour]
                      ])
                    ]),
                    _: 1
                  }, 8, ["errors"]),
                  _createElementVNode("small", _hoisted_147, _toDisplayString(_ctx.helper.trans("labels.turnover_report_send_hour_hint")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_148, [
                _createElementVNode("label", _hoisted_149, _toDisplayString(_ctx.helper.trans("labels.turnover_report_midday_enabled")), 1),
                _createElementVNode("div", _hoisted_150, [
                  _createElementVNode("div", _hoisted_151, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.form.turnoverReportMiddayEnabled) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "turnoverReportMiddayEnabled"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.turnoverReportMiddayEnabled]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_152, [
                _createElementVNode("label", _hoisted_153, _toDisplayString(_ctx.helper.trans("labels.conversion_report_settings")), 1),
                _cache[73] || (_cache[73] = _createElementVNode("div", { class: "col-sm-8" }, null, -1))
              ]),
              _createElementVNode("div", _hoisted_154, [
                _createElementVNode("label", _hoisted_155, _toDisplayString(_ctx.helper.trans("labels.conversion_report_tg_group_id")), 1),
                _createElementVNode("div", _hoisted_156, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.getErrors(`conversionReportTgGroupId`)
                  }, {
                    default: _withCtx((parentProps) => [
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass([parentProps.class, "form-control"]),
                        "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.form.conversionReportTgGroupId) = $event)),
                        type: "text",
                        id: "conversionReportTgGroupId",
                        placeholder: _ctx.helper.trans('labels.conversion_report_tg_group_id_placeholder')
                      }, null, 10, _hoisted_157), [
                        [_vModelText, _ctx.form.conversionReportTgGroupId]
                      ])
                    ]),
                    _: 1
                  }, 8, ["errors"]),
                  _createElementVNode("small", _hoisted_158, _toDisplayString(_ctx.helper.trans("labels.conversion_report_tg_group_id_hint")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_159, [
                _createElementVNode("label", _hoisted_160, _toDisplayString(_ctx.helper.trans("labels.conversion_report_send_hour")), 1),
                _createElementVNode("div", _hoisted_161, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.getConversionReportErrors(`conversionReportSendHour`)
                  }, {
                    default: _withCtx((parentProps) => [
                      _withDirectives(_createElementVNode("select", {
                        id: "conversionReportSendHour",
                        "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.form.conversionReportSendHour) = $event)),
                        class: _normalizeClass(["form-select", parentProps.class])
                      }, [
                        _cache[74] || (_cache[74] = _createElementVNode("option", { value: null }, null, -1)),
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(24, (hour) => {
                          return _createElementVNode("option", {
                            key: hour - 1,
                            value: hour - 1
                          }, _toDisplayString(hour - 1), 9, _hoisted_162)
                        }), 64))
                      ], 2), [
                        [_vModelSelect, _ctx.form.conversionReportSendHour]
                      ])
                    ]),
                    _: 1
                  }, 8, ["errors"]),
                  _createElementVNode("small", _hoisted_163, _toDisplayString(_ctx.helper.trans("labels.conversion_report_send_hour_hint")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_164, [
                _createElementVNode("label", _hoisted_165, _toDisplayString(_ctx.helper.trans("labels.conversion_report_midday_enabled")), 1),
                _createElementVNode("div", _hoisted_166, [
                  _createElementVNode("div", _hoisted_167, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.form.conversionReportMiddayEnabled) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "conversionReportMiddayEnabled"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.conversionReportMiddayEnabled]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_168, [
                _createElementVNode("label", _hoisted_169, _toDisplayString(_ctx.helper.trans("labels.conversion_stat_tg_group_id")), 1),
                _createElementVNode("div", _hoisted_170, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.getErrors(`conversionStatTgGroupId`)
                  }, {
                    default: _withCtx((parentProps) => [
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass([parentProps.class, "form-control"]),
                        "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.form.conversionStatTgGroupId) = $event)),
                        type: "text",
                        id: "conversionStatTgGroupId",
                        placeholder: _ctx.helper.trans('labels.conversion_stat_tg_group_id_placeholder')
                      }, null, 10, _hoisted_171), [
                        [_vModelText, _ctx.form.conversionStatTgGroupId]
                      ])
                    ]),
                    _: 1
                  }, 8, ["errors"]),
                  _createElementVNode("small", _hoisted_172, _toDisplayString(_ctx.helper.trans("labels.conversion_stat_tg_group_id_hint")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_173, [
                _createElementVNode("label", _hoisted_174, _toDisplayString(_ctx.helper.trans("labels.receipt_site_to_merchant")), 1),
                _createElementVNode("div", _hoisted_175, [
                  _createElementVNode("div", _hoisted_176, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.form.isClientReceiptNotificationEnabled) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "isClientReceiptNotificationEnabled"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.isClientReceiptNotificationEnabled]
                    ])
                  ])
                ])
              ]),
              (_ctx.dealCompletedNotifyFeatureEnabled)
                ? (_openBlock(), _createElementBlock("div", _hoisted_177, [
                    _createElementVNode("label", _hoisted_178, _toDisplayString(_ctx.helper.trans("labels.deal_completed_tg_notify_merchant")), 1),
                    _createElementVNode("div", _hoisted_179, [
                      _createElementVNode("div", _hoisted_180, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.form.isDealCompletedNotificationEnabled) = $event)),
                          class: "form-check-input",
                          type: "checkbox",
                          id: "isDealCompletedNotificationEnabled"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.form.isDealCompletedNotificationEnabled]
                        ])
                      ]),
                      (_ctx.form.isDealCompletedNotificationEnabled && !_ctx.form.tgChatGroupId)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_181, _toDisplayString(_ctx.helper.trans("labels.deal_completed_tg_notify_merchant_no_group_warning")), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.reuseMinCapFeatureEnabled)
                ? (_openBlock(), _createElementBlock("div", _hoisted_182, [
                    _createElementVNode("label", _hoisted_183, _toDisplayString(_ctx.helper.trans("labels.reuse_min_cap")), 1),
                    _createElementVNode("div", _hoisted_184, [
                      _createElementVNode("div", _hoisted_185, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.form.reuseMinCapEnabled) = $event)),
                          class: "form-check-input",
                          type: "checkbox",
                          id: "reuseMinCapEnabled"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.form.reuseMinCapEnabled]
                        ])
                      ]),
                      _createVNode(_component_FormInputWrapper, {
                        errors: _ctx.getReuseMinCapErrors()
                      }, {
                        default: _withCtx((parentProps) => [
                          _createVNode(_component_CurrencyAmountMapInput, {
                            modelValue: _ctx.form.reuseMinCaps,
                            "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.form.reuseMinCaps) = $event)),
                            disabled: !_ctx.form.reuseMinCapEnabled,
                            class: _normalizeClass(parentProps.class)
                          }, null, 8, ["modelValue", "disabled", "class"])
                        ]),
                        _: 1
                      }, 8, ["errors"]),
                      _createElementVNode("small", _hoisted_186, _toDisplayString(_ctx.helper.trans("labels.reuse_min_cap_hint")), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_187, [
                _createElementVNode("label", _hoisted_188, _toDisplayString(_ctx.helper.trans("labels.receipt_site_to_trader")), 1),
                _createElementVNode("div", _hoisted_189, [
                  _createElementVNode("div", _hoisted_190, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.form.siteUploadForwardEnabled) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "siteUploadForwardEnabled"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.siteUploadForwardEnabled]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_191, [
                _createElementVNode("label", _hoisted_192, _toDisplayString(_ctx.helper.trans("labels.anti_fraud_enabled")), 1),
                _createElementVNode("div", _hoisted_193, [
                  _createElementVNode("div", _hoisted_194, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.isAntiFraudEnabled) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "isAntiFraudEnabled"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.isAntiFraudEnabled]
                    ])
                  ])
                ])
              ]),
              (_ctx.isAntiFraudEnabled)
                ? (_openBlock(), _createElementBlock("div", _hoisted_195, [
                    _createElementVNode("label", _hoisted_196, _toDisplayString(_ctx.helper.trans("labels.anti_fraud_cancel_deal")), 1),
                    _createElementVNode("div", _hoisted_197, [
                      _createVNode(_component_FormInputWrapper, {
                        errors: _ctx.getErrors(`antiFraudCancelDeal`)
                      }, {
                        default: _withCtx((parentProps) => [
                          _withDirectives(_createElementVNode("input", {
                            class: _normalizeClass([parentProps.class, "form-control"]),
                            "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.form.antiFraudCancelDeal) = $event)),
                            type: "number",
                            min: "1",
                            id: "antiFraudCancelDeal",
                            placeholder: "Количество сделок для срабатывания антифрода",
                            onInput: _cache[59] || (_cache[59] = 
//@ts-ignore
(...args) => (_ctx.validatePositiveNumber && _ctx.validatePositiveNumber(...args)))
                          }, null, 34), [
                            [_vModelText, _ctx.form.antiFraudCancelDeal]
                          ])
                        ]),
                        _: 1
                      }, 8, ["errors"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isAntiFraudEnabled)
                ? (_openBlock(), _createElementBlock("div", _hoisted_198, [
                    _createElementVNode("label", _hoisted_199, _toDisplayString(_ctx.helper.trans("labels.anti_fraud_cancel_deal_banned_seconds")), 1),
                    _createElementVNode("div", _hoisted_200, [
                      _createElementVNode("div", _hoisted_201, [
                        _createVNode(_component_FormInputWrapper, {
                          errors: _ctx.getErrors(`antiFraudCancelDealBannedSeconds`)
                        }, {
                          default: _withCtx((parentProps) => [
                            _withDirectives(_createElementVNode("input", {
                              class: _normalizeClass([parentProps.class, "form-control"]),
                              "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.banHours) = $event)),
                              type: "number",
                              min: "0",
                              max: "336",
                              id: "banHours",
                              placeholder: _ctx.helper.trans('labels.hours'),
                              onInput: _cache[61] || (_cache[61] = 
//@ts-ignore
(...args) => (_ctx.validateBanHours && _ctx.validateBanHours(...args)))
                            }, null, 42, _hoisted_202), [
                              [_vModelText, _ctx.banHours]
                            ])
                          ]),
                          _: 1
                        }, 8, ["errors"])
                      ]),
                      _createElementVNode("div", _hoisted_203, [
                        _createVNode(_component_FormInputWrapper, {
                          errors: _ctx.getErrors(`antiFraudCancelDealBannedSeconds`)
                        }, {
                          default: _withCtx((parentProps) => [
                            _withDirectives(_createElementVNode("input", {
                              class: _normalizeClass([parentProps.class, "form-control"]),
                              "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.banMinutes) = $event)),
                              type: "number",
                              min: "1",
                              max: "59",
                              id: "banMinutes",
                              placeholder: _ctx.helper.trans('labels.minutes'),
                              onInput: _cache[63] || (_cache[63] = 
//@ts-ignore
(...args) => (_ctx.validateBanMinutes && _ctx.validateBanMinutes(...args)))
                            }, null, 42, _hoisted_204), [
                              [_vModelText, _ctx.banMinutes]
                            ])
                          ]),
                          _: 1
                        }, 8, ["errors"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.form.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_205, [
                    _createElementVNode("label", _hoisted_206, _toDisplayString(_ctx.helper.trans("labels.2fa")), 1),
                    _createElementVNode("div", _hoisted_207, [
                      (_ctx.form?.is2faEnabled)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_208, _toDisplayString(_ctx.helper.trans('labels.enabled')), 1))
                        : _createCommentVNode("", true),
                      (!_ctx.form?.is2faEnabled)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_209, [
                            _cache[75] || (_cache[75] = _createElementVNode("i", { class: "fa fa-warning" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.disabled')), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.form?.is2faEnabled)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            type: "button",
                            class: "btn btn-danger ms-2 btn-sm text-capitalize-first",
                            onClick: _cache[64] || (_cache[64] = _withModifiers(($event: any) => (_ctx.disable2fa(_ctx.form.id)), ["prevent"]))
                          }, _toDisplayString(_ctx.helper.trans("labels.disable")), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isAdmin && _ctx.form.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_210, [
                    _createElementVNode("div", _hoisted_211, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-outline-secondary btn-sm text-capitalize-first",
                        onClick: _cache[65] || (_cache[65] = _withModifiers(($event: any) => (_ctx.$emit('open-settings-history')), ["prevent"]))
                      }, _toDisplayString(_ctx.helper.trans('labels.settings_history')), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_ConfirmModal, { ref: "twoFaConfirmModal" }, null, 512),
    _createVNode(_component_MerchantReceiptForwardModal, {
      ref: "receiptForwardModal",
      onApply: _ctx.applyReceiptForwardSettings
    }, null, 8, ["onApply"])
  ]))
}